export { default as ChevronDownSolidIcon } from './ChevronDownSolidIcon';
